module.exports = __webpack_public_path__ + "static/media/image-1200.9ccbd81c.webp";